<template>
  <div>
  <div class="index_bg">
    
		<div class="btn" style="margin-top: 110vw;">
		
      <div class="butt">
			<van-button type="default" @click="code" size="large" class="index_btn"><img src="../assets/images/button1.png"></van-button>
      </div>
      
    </div>
    <div class="btn">
      <div class="butt">
      <router-link :to="{name: 'DatiRules'}"><van-button type="default" size="large" class="index_btn"><img src="../assets/images/button2.png" ></van-button>
      </router-link>
      </div>
    </div>
  </div>

			<!-- <van-dialog v-model="show_gzh" title="安徽人大">
				<div><img src="http://oss.ahxmgk.com/yun/uploads/image/2021/11/03/5a05272e42987ad3c5bd307916385d5b.jpg" style="width:100%; margin: 20px auto;" />
      
				</div>
			</van-dialog> -->
			
      
      
			<van-dialog v-model="cshow" title="" :show-confirm-button="true" :beforeClose="closeCode">
          <div style="height: 56px;overflow: hidden;">
            <div class="l-captcha" data-callback="getResponse" data-site-key="776551c9cc8a35b7943aa0e9a9f625e5"></div>
        
          </div>
            <p class="ppppp">提示：若显示不出验证图片，请刷新页面</p>
        
				
			</van-dialog>

			

    
 
  </div>
  
</template>

<script>
import Qcode from '@/components/qcode.vue'
import { share } from '@/api/app.js'
import { login, userLogin} from '@/api/auth'
import { getUrl, isWeiXin } from '@/utils/app'
import { getToken, setToken } from '@/utils/auth'
import { Toast } from 'vant'
import { getUserInfo,setUserInfo,datiShare} from '@/api/user'

export default {
  name: 'Home',
  components: {Qcode},
  data () {
    return {
      show: false,
      show_subscribe: true,
      show_gzh:true,
      cshow: false,
      info: this.$store.state.acc,
      user: this.$store.state.user,
      luosimao_code: '',
      showuser:false,
      columns: ['大兴镇','龙岗开发区','嘉山路街道','长淮街道','胜利路街道','和平路街道','明光路街道','三里街街道','铜陵路街道','七里站街道','城东街道','红光街道','方庙街道','其他'],
      username:'',
      mobile:'',
      showPicker: false,
      value:'',
      department:'',
      address:'',
      shareIsShow:false


    }
  },

  created() {
    if(!isWeiXin())this.show = true
    
  },
  methods: {
    closeCode(action, done) {
      let dom = document.getElementById("lc-captcha-response")
      if(dom.value) {
        this.luosimao_code = dom.value
        this.$store.commit('SET_LUOSIMAO_CODE', this.luosimao_code)
        // this.userinfo()
        this.start()
      }
      done()
    },
    onConfirm(value) {
      this.address = value;
      this.showPicker = false;
    },
    code() {
      this.cshow = true
      // if(!window.LUOCAPTCHA) {
        let dom = document.getElementById("luosimao");
        if(dom){
           dom.parentNode.removeChild(dom);
        }
        var c = document.createElement('script');c.type = 'text/javascript';c.async = true;c.id="luosimao"
        c.src = ('https:' == document.location.protocol ? 'https://' : 'http://') + 'captcha.luosimao.com/static/dist/captcha.js';
        var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(c, s);
      // }else{
      //   window.LUOCAPTCHA.reset()
      // }
      
      // return 
    },
    userinfo(){
      this.showuser = true
      this.cshow = false


    },
    onSubmit(values){
      Toast('加载中');

      setUserInfo(values).then(res=>{
            // setToken(res.access_token)
            this.$store.commit('SET_USER', res.user)
            getUserInfo().then(res=>{
            this.$store.commit('SET_USER', res)
            Toast.clear()
             this.start()
            })
            

          })
      
      // start()

    },
    validator(val) {
      return /^1(3|4|5|6|7|8|9)\d{9}$/.test(val);
    },
    start() {
      let now_time=new Date();
      let y = now_time.getFullYear();
      let MM = now_time.getMonth() + 1;
      MM = MM < 10 ? ('0' + MM) : MM;
      let d = now_time.getDate();
      d = d < 10 ? ('0' + d) : d;
      let h = now_time.getHours();
      h = h < 10 ? ('0' + h) : h;
      let m = now_time.getMinutes();
      m = m < 10 ? ('0' + m) : m;
      let s = now_time.getSeconds();
      s = s < 10 ? ('0' + s) : s;
      this.time_now = y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s  ;      		
			
			console.log(this.info.number);
      if(this.time_now < this.info.start_time || this.time_now > this.info.end_time ){
        this.$dialog.alert({
          message: '活动暂未开放！',
        });
        return false
      }
      //答题时间在8:00到24:00之间
      let nowtime=new Date();
			
   //    if(now_time.getHours()>'8' && now_time.getHours()<'10' || now_time.getHours()>'12' && now_time.getHours()<'14' || now_time.getHours()>'17' && now_time.getHours()<'21'){
					
					
   //    }else{
			// 		this.$dialog.alert({
			// 			message: '请于8:00-10:00，12:00-14:00, 17:00-21:00 之间答题！',
			// 		});
			// 		return false
			// }
      
      //判断用户答题次数
      if(this.user.number == 0) {
        let message = '答题机会已经用完，请明天再来！'
        this.$dialog.confirm({
            message: message,
          });
          return
        
        
        
      }
      //跳转到答题页面
      this.$router.push({ name: 'DatiView', params: { q: this.info.code }})
      // 
	  
    }
  }
}


</script>
<style scoped>
  button{
    margin-top: 2vh;
  }
  button img{
    width: 50%;
  }
  .w90{
    width: 90%;
    margin: 0 auto;

  }
  .titlepic{
    padding-top: 10vh;


  }
  .titlepic img{
    width: 100%;
  }
  
  #l-captcha-float_9qbmiexj5{
    top: 100px;
    left: 10%;

  }
  .van-dialog__confirm, .van-dialog__confirm:active{
    
    color: #000;
  }
	
.index_bg{
  background: url(../assets/images/index.jpg) no-repeat center;
  background-size: 100% 100%;
  width: 100%;
  height: 100%;
  /* text-align: center; */
  position: fixed;
  top: 0;
  bottom: 0;
}
.index_bg .btn{
	/*width: 50vw;
	
  float: left;*/
  /*margin-top: 75vh;*/
}
.index_bg .btn .butt{
  width: 40vw;
  margin: auto;
  
}
.index_btn{
  margin-top: 3vh;
  /* width: 55vw; */
  /* height: 7vh; */
  font-size: 5vw;
  /* line-height: 7vh; */
  border-radius: 25px;
}
.index_btn:first-child{
  margin-top: 3vh;
}
.index_btn img{
	width: 100%;
	height: 100%;
}
.van-button--default{
	background-color: rgba(255,255,255,0);
	border: unset;
}
.van-button--large{
	height: unset;
}
@media (min-width:720px){
    .index_bg{
        width: 720px;
    }
	.index_btn{
		width: 100%;
		margin-top: 0;
	}
}
.l-captcha { margin: 10px auto;}
.ppppp{line-height: 30px;text-indent: 1em;
    font-size: 12px;}
  .share{
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 30;
    background: rgba(0,0,0,0.5);
  }
</style>
